import { Typography, Grid, Paper } from "@mui/material";

interface DataItem {
  label: string;
  value: number | string; // Allow both numbers and strings
}

interface AnalyticsDashboardProps {
  data: DataItem[]; // Array of data items
  title: string; // New prop for the title
}

const AnalyticsDashboard: React.FC<AnalyticsDashboardProps> = ({
  data,
  title,
}) => {
  // Check if data is empty
  if (!data || data.length === 0) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
            <Typography variant="h6">No data available</Typography>
          </Paper>
        </Grid>
      </Grid>
    );
  }

  return (
    <Paper
      elevation={3}
      sx={{ p: 3, mt: 2, backgroundColor: "background.paper", borderRadius: 2 }}
    >
      <Typography variant="h5" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={3}>
        {data.map((item, index) => (
          <Grid item xs={12} md={3} key={index}>
            <Paper elevation={1} sx={{ p: 2, textAlign: "center" }}>
              <Typography variant="h4" color="primary">
                {item.value}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.label}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default AnalyticsDashboard;
